import React, { createContext, useContext } from "react";
import { useNotifications as useNotificationsHook, Notification } from "hooks/notifications/useNotifications";

interface NotificationsContextType {
  notifications: Notification[];
  unreadCount: number;
  loading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: (id: string) => Promise<void>;
  markPostAsRead: (postId: string) => Promise<void>;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const NotificationsProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { notifications, unreadCount, loading, fetchNotifications, markAsRead, markPostAsRead } = useNotificationsHook();

  return (
    <NotificationsContext.Provider value={{ notifications, unreadCount, loading, fetchNotifications, markAsRead, markPostAsRead }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) throw new Error("useNotifications must be used within NotificationsProvider");
  return context;
};
